<div class="section" *ngIf="showThemePreference || showAlertsPreference">
  <div class="title">Preferences</div>
  <div class="content" *ngIf="showThemePreference">
    <div class="col">
      <div class="row">
        <div class="column">
          <span class="text title" i18n="theme title|Theme title into profile page@@themeTitleProfilePage">Change
            theme</span>
          <span class="text description" i18n="
              theme description|Theme description into profile page@@themeDescriptionProfilePage">View the application
            in a light or dark theme</span>
        </div>
        <mat-button-toggle-group class="atweb-btn" name="theme" aria-label="Application Theme" [value]="defaultTheme"
          (change)="onChangeTheme($event)">
          <mat-button-toggle value="light"
            i18n="light theme btn|Light theme btn into profile page@@lightThemeBtnProfilePage">Light</mat-button-toggle>
          <mat-button-toggle value="dark"
            i18n="dark theme btn|Dark theme btn into profile page@@darkThemeBtnProfilePage">Dark</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>

  <!-- Temporarily hidden (BE not ready, until PTC 1.1): OLPTC-3867 -->
  <!--<div class="content">
      <div class="col">
        <div class="row">
          <div class="column">
            <span class="text title">Show pop-up alerts and notifications for active test</span>
            <span class="text description">See pop-up messages when active test alerts and notifications happen</span>
          </div>
          <mat-slide-toggle color="primary" name="enableWebUIAlerts" [(ngModel)]="enableWebUIAlerts" (change)="onUserPrefsChange($event, 'enableWebUIAlerts')"></mat-slide-toggle>
        </div>
      </div>
    </div>-->

  <!--<div class="content" *ngIf="!userAuth.readOnly">
      <div class="col">
        <div class="row">
          <div class="column">
            <span class="text title">Show first step wizard</span>
            <span class="text description">See the first-time user tutorial on your next login</span>
          </div>
          &lt;!&ndash;<md-switch ng-model="userService.showFirstStepWizard" aria-label="Enable first step wizard"></md-switch>&ndash;&gt;
          <mat-slide-toggle></mat-slide-toggle>
        </div>
      </div>
    </div>-->

  <div class="content" *ngIf="showAlertsPreference">
    <div class="col">
      <div class="row">
        <div class="column">
          <span class="text title">Enable email alerts</span>
          <span class="text description">Receive email messages when alerts happen</span>
        </div>
        <mat-slide-toggle color="primary" name="isEmailNotificationEnabled" [(ngModel)]="isEmailNotificationEnabled"
          (change)="onEnableOverallEmailAlertsChange($event)"></mat-slide-toggle>
      </div>
      <div [ngClass]="{ slidedown: isEmailNotificationEnabled, slideup: !isEmailNotificationEnabled }">
        <nrwl-alert-configuration [alertPreferenceSubject]="alertPreferenceSubject"></nrwl-alert-configuration>
      </div>
    </div>
  </div>
</div>